import { render, staticRenderFns } from "./algemene-gegevens.vue?vue&type=template&id=50acf801&scoped=true"
import script from "./algemene-gegevens.vue?vue&type=script&lang=js"
export * from "./algemene-gegevens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50acf801",
  null
  
)

export default component.exports